<template>
  <b-container fluid>
      <metabase :code="936" />
  </b-container>
</template>
<script>
import {
    BContainer,
    BCard,
} from 'bootstrap-vue';

import Metabase from '../components/Metabase.vue';

export default {
    components: {
        BContainer,
        BCard,
        Metabase,
    },
};
</script>
